import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Modal, Mo, Flex, Input, Checkbox } from 'nallian-shared-ui/lib/components';

const WhiteCheckbox = styled(Checkbox)`
  label {
    color: white !important;
    margin: -0.2rem 0 0;
  }
`;

const TypeToConfirmModal = ({
  onConfirm,
  onCancel,
  header,
  loading,
  value,
  extraCheckSentence,
}) => {
  const { t } = useTranslation();
  const [confirmText, setConfirmText] = useState('');
  const [extraCheckAccepted, setExtraCheckAccepted] = useState(false);

  const handleChangeConfirmText = useCallback((_, target) => setConfirmText(target.value), [
    setConfirmText,
  ]);

  const handleExtraCheckChange = useCallback((_, { checked }) => setExtraCheckAccepted(checked), [
    setExtraCheckAccepted,
  ]);

  useEffect(() => {
    return () => {
      setConfirmText('');
      setExtraCheckAccepted(false);
    };
  }, [setConfirmText, setExtraCheckAccepted]);

  const isConfirmDisabled =
    loading || confirmText !== value || (extraCheckSentence && !extraCheckAccepted);

  return (
    <Modal open basic size="tiny">
      <Mo.Header>{header}</Mo.Header>
      <Mo.Content>
        <Flex margin="0 0 1rem">{t('pleaseTypeToEnableConfirmButton', { message: value })}</Flex>
        <Input fluid placeholder={t('pleaseTypeHere')} onChange={handleChangeConfirmText} />
        {extraCheckSentence && (
          <Flex margin="1rem 0 0">
            <WhiteCheckbox
              label={extraCheckSentence}
              checked={extraCheckAccepted}
              onChange={handleExtraCheckChange}
            />
          </Flex>
        )}
      </Mo.Content>
      <Mo.Actions>
        <Button inverted content={t('cancel')} onClick={onCancel} disabled={loading} />
        <Button
          primary
          inverted
          content={t('confirm')}
          onClick={onConfirm}
          loading={loading}
          disabled={isConfirmDisabled}
        />
      </Mo.Actions>
    </Modal>
  );
};

TypeToConfirmModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  value: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  extraCheckSentence: PropTypes.string,
};

TypeToConfirmModal.defaultProps = {
  loading: false,
  extraCheckSentence: null,
};

export default TypeToConfirmModal;
